export default __webpack_public_path__ + "static/media/brave_zone_xl3.842e8677.png";